import { useState, useEffect } from "react";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import { Undo2 } from "lucide-react";
import CartChatpterComp from "./CartChatpterComp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function True_False({ true_false, picture }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [isWaiting, setIsWaiting] = useState(false);
  const [value, setValue] = useState(false);
  const [tab, setTab] = useState(0);
  const [userAnswer, setUserAnswer] = useState([]);
  const [userAllContent, setUserAllContent] = useState({
    userId: "",
    name: "",
    class_name: "",
    true_false: null,
  });
  const user = JSON.parse(localStorage.getItem("postUser"));
  const contentValue = useSelector((state) => state.extra.value);
  const navigate = useNavigate();
  const currentItem = true_false[currentIndex];

  useEffect(() => {
    if (currentIndex === true_false.length) {
      setUserAllContent((prev) => ({
        userId: user._id,
        name: contentValue.name,
        class_name: contentValue.class_name,
        true_false: userAnswer,
      }));
      setValue(true);
      setTab(1);
    }
  }, [currentIndex, true_false.length]);

  const handleNextButton = () => {
    if (currentIndex < true_false.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBackButton = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChoice = (choice) => {
    if (answers[currentIndex] || isWaiting) return;

    setAnswers({ ...answers, [currentIndex]: choice });
    let choiseStatus = false;
    if (true_false[currentIndex].status === choice) {
      choiseStatus = true;
    }
    setIsWaiting(true);
    setUserAnswer((prev) => [
      ...prev,
      {
        sentenceId: true_false[currentIndex]._id,
        sentence: true_false[currentIndex].sentence,
        givenAnswer: choice,
        status: choiseStatus,
      },
    ]);
    setTimeout(() => {
      setCurrentIndex((prev) => prev + 1);
      setIsWaiting(false);
    }, 500);
  };

  // 🟢 Eğer tab 1 ise doğrudan başarı ekranını göster
  if (tab === 1) {
    return (
      <CartChatpterComp
        value={value}
        status="true_false"
        userAllContent={userAllContent}
      />
    );
  }

  // 🟢 Sadece tab 0 iken index kontrolü yap (null dönme)
  if (currentIndex >= true_false.length) {
    return null; // veya loading spinner
  }

  return (
    <div className="flex flex-col w-full  gap-4 max-w-5xl mx-auto rounded-xl ">
      <div className="grid grid-cols-4 p-2  items-center w-full gap-4 bg-yellow-500 rounded-xl">
        {/* Sol Kısım: Egzersiz Başlığı */}
        <div className="col-span-3 md:col-span-3 flex items-center">
          <span className="font-medium   rounded-xl text-white text-xl p-2">
            True False
          </span>
        </div>
        {/* Sağ Kısım: Geri Dön Butonu */}
        <div className="col-span-1 md:col-span-1 flex justify-end items-center">
          <button
            onClick={() => navigate("/extraPage")}
            className="bg-gray-100 h-10 w-10 text-red-500 hover:bg-red-500 hover:text-gray-100 
            transition-all rounded-full flex items-center justify-center shadow-lg active:scale-90 shrink-0"
          >
            <Undo2 size={20} />
          </button>
        </div>
      </div>
      <div className="flex flex-col w-full bg-purple-500 gap-4 max-w-5xl mx-auto rounded-xl ">
        {/* Üst Kısım: İlerleme Çubukları ve Geri Dönüş */}

        <div className="flex flex-row items-center justify-between gap-4 ">
          {/* Ana İçerik */}
          <div className="flex-1 flex flex-col items-center gap-4">
            <div className="grid grid-cols-12 p-2 justify-center items-center w-full gap-2 md:gap-4">
              {/* Geri Butonu */}
              <div
                className={`col-span-2 sm:col-span-1 flex justify-start items-center ${
                  currentIndex === 0 ? "opacity-30 pointer-events-none" : ""
                }`}
              >
                <BackButton handleBackButton={handleBackButton} />
              </div>

              {/* Orta Kısım (Noktalar / Progress) */}
              <div className="col-span-8 sm:col-span-10 flex justify-center items-center">
                <div className="flex flex-wrap justify-center items-center gap-2 p-2 rounded-2xl max-w-full">
                  {true_false.map((_, i) => {
                    const isAnswered =
                      answers[i] !== undefined && answers[i] !== null;
                    const isCorrect = answers[i] === true_false[i].status;
                    return (
                      <div
                        key={i}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          i === currentIndex
                            ? "bg-yellow-400 scale-150 shadow-md"
                            : isAnswered
                              ? isCorrect
                                ? "bg-green-400"
                                : "bg-red-400"
                              : "bg-purple-300"
                        }`}
                      />
                    );
                  })}
                </div>
              </div>

              {/* İleri Butonu */}
              <div
                className={`col-span-2 sm:col-span-1 flex justify-end items-center ${
                  currentIndex === true_false.length - 1
                    ? "opacity-30 pointer-events-none"
                    : ""
                }`}
              >
                <NextButton handleNextButton={handleNextButton} />
              </div>
            </div>
            <div
              className="w-full max-w-2xl rounded-2xl shadow-inner relative
             border-l-6 border-yellow-500 min-h-[120px]"
            >
              <img
                src={picture}
                alt="Exercise"
                className="w-full h-full rounded-xl aspect-video"
              />
            </div>
            {/* bilgisayar ve tablet için */}
            <div className="w-full max-w-2xl lg:grid grid-cols-12 rounded-xl p-6 gap-4 text-center items-stretch hidden">
              {/* 🟢 TRUE BUTONU */}
              {(() => {
                const option = "true";
                const isSelected = answers[currentIndex] === option;
                const isCorrectAnswer = currentItem.status === option;
                const hasAnswered = answers[currentIndex] !== undefined;

                let buttonStyle =
                  "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                if (hasAnswered) {
                  if (isCorrectAnswer) {
                    buttonStyle =
                      "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                  } else if (isSelected) {
                    buttonStyle =
                      "bg-red-500 text-white border-red-600 opacity-70";
                  } else {
                    buttonStyle =
                      "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                  }
                }

                return (
                  <button
                    disabled={hasAnswered || isWaiting}
                    onClick={() => handleChoice(option)}
                    className={`col-span-3 flex flex-col justify-center items-center gap-2 rounded-2xl py-4  transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                  >
                    <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                      {hasAnswered && isCorrectAnswer ? "⭐" : "✅"}
                    </span>
                    <span className="text-xl font-bold uppercase tracking-wide">
                      true
                    </span>
                  </button>
                );
              })()}

              {/* 🟡 ORTA KISIM: CÜMLE ALANI */}
              <div className="bg-gray-100 col-span-6 flex flex-col justify-center items-center gap-2 rounded-2xl p-4 shadow-md border-l-4 border-yellow-400 min-h-[120px]">
                {currentItem.emoji && (
                  <span className="text-3xl mb-1">{currentItem.emoji}</span>
                )}
                <p className="text-md md:text-lg font-bold text-purple-900 leading-relaxed">
                  {currentItem.sentence}
                </p>

                {/* Bildirim Mesajı */}
                {answers[currentIndex] !== undefined && (
                  <span
                    className={`text-xs font-black uppercase tracking-wider mt-1 px-3 py-1 rounded-full bg-white bg-opacity-30 ${
                      answers[currentIndex] === currentItem.status
                        ? "text-green-900"
                        : "text-red-900"
                    }`}
                  >
                    {answers[currentIndex] === currentItem.status
                      ? "Well Done! ⭐"
                      : "Try Again! 💪"}
                  </span>
                )}
              </div>

              {/* 🔴 FALSE BUTONU */}
              {(() => {
                const option = "false";
                const isSelected = answers[currentIndex] === option;
                const isCorrectAnswer = currentItem.status === option;
                const hasAnswered = answers[currentIndex] !== undefined;

                let buttonStyle =
                  "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                if (hasAnswered) {
                  if (isCorrectAnswer) {
                    buttonStyle =
                      "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                  } else if (isSelected) {
                    buttonStyle =
                      "bg-red-500 text-white border-red-600 opacity-70";
                  } else {
                    buttonStyle =
                      "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                  }
                }

                return (
                  <button
                    disabled={hasAnswered || isWaiting}
                    onClick={() => handleChoice(option)}
                    className={`col-span-3 flex flex-col justify-center items-center gap-2 
                    rounded-2xl py-4  transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                  >
                    <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                      {hasAnswered && isCorrectAnswer ? "⭐" : "❌"}
                    </span>
                    <span className="text-xl font-bold uppercase tracking-wide">
                      false
                    </span>
                  </button>
                );
              })()}
            </div>
            {/* cep telefon için */}
            <div className="w-full max-w-2xl grid grid-row-2 rounded-xl p-6 gap-4 text-center items-stretch lg:hidden ">
              {/* 🟡 ORTA KISIM: CÜMLE ALANI */}
              <div className="bg-gray-100 row-span-1 flex flex-col justify-center items-center gap-2 rounded-2xl p-4 shadow-md border-l-4 border-yellow-400 min-h-[120px]">
                {currentItem.emoji && (
                  <span className="text-3xl mb-1">{currentItem.emoji}</span>
                )}
                <p className="text-md md:text-lg font-bold text-purple-900 leading-relaxed">
                  {currentItem.sentence}
                </p>

                {/* Bildirim Mesajı */}
                {answers[currentIndex] !== undefined && (
                  <span
                    className={`text-xs font-black uppercase tracking-wider mt-1 px-3 py-1 rounded-full bg-white bg-opacity-30 ${
                      answers[currentIndex] === currentItem.status
                        ? "text-green-900"
                        : "text-red-900"
                    }`}
                  >
                    {answers[currentIndex] === currentItem.status
                      ? "Well Done! ⭐"
                      : "Try Again! 💪"}
                  </span>
                )}
              </div>
              {/* 🟢 TRUE BUTONU */}
              <div className="row-span-1 flex justify-between items-center gap-2 ">
                {(() => {
                  const option = "true";
                  const isSelected = answers[currentIndex] === option;
                  const isCorrectAnswer = currentItem.status === option;
                  const hasAnswered = answers[currentIndex] !== undefined;

                  let buttonStyle =
                    "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                  if (hasAnswered) {
                    if (isCorrectAnswer) {
                      buttonStyle =
                        "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                    } else if (isSelected) {
                      buttonStyle =
                        "bg-red-500 text-white border-red-600 opacity-70";
                    } else {
                      buttonStyle =
                        "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                    }
                  }

                  return (
                    <button
                      disabled={hasAnswered || isWaiting}
                      onClick={() => handleChoice(option)}
                      className={` flex flex-col justify-center items-center gap-2 w-full rounded-2xl py-4  transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                    >
                      <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                        {hasAnswered && isCorrectAnswer ? "⭐" : "✅"}
                      </span>
                      <span className="text-md font-bold uppercase tracking-wide">
                        true
                      </span>
                    </button>
                  );
                })()}
                {/* 🔴 FALSE BUTONU */}
                {(() => {
                  const option = "false";
                  const isSelected = answers[currentIndex] === option;
                  const isCorrectAnswer = currentItem.status === option;
                  const hasAnswered = answers[currentIndex] !== undefined;

                  let buttonStyle =
                    "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                  if (hasAnswered) {
                    if (isCorrectAnswer) {
                      buttonStyle =
                        "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                    } else if (isSelected) {
                      buttonStyle =
                        "bg-red-500 text-white border-red-600 opacity-70";
                    } else {
                      buttonStyle =
                        "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                    }
                  }

                  return (
                    <button
                      disabled={hasAnswered || isWaiting}
                      onClick={() => handleChoice(option)}
                      className={`flex flex-col justify-center items-center gap-1 
                    rounded-2xl py-4  transition-all duration-200 w-full active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                    >
                      <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                        {hasAnswered && isCorrectAnswer ? "⭐" : "❌"}
                      </span>
                      <span className="text-md font-bold uppercase tracking-wide">
                        false
                      </span>
                    </button>
                  );
                })()}
              </div>
            </div>
          </div>

          {/* İleri Butonu */}
          {/* <div
            className={
              currentIndex === true_false.length - 1
                ? "opacity-30 pointer-events-none"
                : ""
            }
          >
            <NextButton handleNextButton={handleNextButton} />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default True_False;
